import React from "react";
import { Row, Col } from "react-bootstrap";
import { Icon } from "@iconify/react";
import styles from './AccessosWiki.module.scss';

/**
 * Wiki - Secao Integracao Notazz
 *
 * Documentacao completa sobre a integracao com o Notazz para emissao
 * automatica de notas fiscais. Voltada para produtores (nao tecnica).
 */
const NotazzWiki = () => {
  return (
    <div className={styles.wikiAccessos}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroBadge}>
          <Icon icon="mdi:file-document-check" />
          <span>Notas Fiscais Automaticas</span>
        </div>
        <p className={styles.heroText}>
          Emita notas fiscais automaticamente para cada venda confirmada.
          Configure uma vez e o sistema cuida do resto — o comprador recebe o PDF por email.
        </p>
      </section>

      {/* O que e */}
      <section className={styles.section}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionTitle}>O que e a Integracao Notazz?</span>
          <p className={styles.sectionSubtitle}>
            Emissao automatica de NF-e e NFS-e
          </p>
        </div>

        <div className={styles.infoCard}>
          <Icon icon="mdi:information" className={styles.infoIcon} />
          <div>
            <p>
              O <strong>Notazz</strong> e uma plataforma de emissao de notas fiscais eletronicas.
              Com a integracao, toda vez que uma venda for confirmada (PIX, cartao ou boleto),
              o sistema <strong>emite a nota fiscal automaticamente</strong> sem que voce precise
              fazer nada manualmente.
            </p>
            <p style={{ marginTop: '12px', marginBottom: 0 }}>
              Alem disso, quando a nota e autorizada pela SEFAZ, o <strong>comprador recebe
              automaticamente um email</strong> com o link para baixar o PDF da nota fiscal.
            </p>
          </div>
        </div>
      </section>

      {/* Como Configurar */}
      <section className={styles.section}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionTitle}>Como Configurar?</span>
          <p className={styles.sectionSubtitle}>
            3 passos simples para ativar
          </p>
        </div>

        <Row className="g-4">
          <Col lg={6}>
            <div className={styles.configCard}>
              <div className={styles.configNumber}>1</div>
              <div className={styles.configIcon}>
                <Icon icon="mdi:key-variant" />
              </div>
              <div className={styles.configContent}>
                <span className={styles.configTitle}>
                  Obtenha sua API Key do Notazz
                </span>
                <p>
                  Acesse o painel do <strong>Notazz</strong> (app.notazz.com), va em
                  <strong> Configuracoes &gt; API</strong> e copie sua chave de API.
                </p>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className={styles.configCard}>
              <div className={styles.configNumber}>2</div>
              <div className={styles.configIcon}>
                <Icon icon="mdi:link-variant" />
              </div>
              <div className={styles.configContent}>
                <span className={styles.configTitle}>
                  Configure no Pagmus
                </span>
                <p>
                  No menu lateral, acesse <strong>Operacoes &gt; Notazz</strong>.
                  Cole a API Key no campo indicado e clique em <strong>Salvar</strong>.
                  A chave sera validada automaticamente.
                </p>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className={styles.configCard}>
              <div className={styles.configNumber}>3</div>
              <div className={styles.configIcon}>
                <Icon icon="mdi:clipboard-list-outline" />
              </div>
              <div className={styles.configContent}>
                <span className={styles.configTitle}>
                  Crie Regras de Emissao
                </span>
                <p>
                  Clique em <strong>Nova Regra</strong>, selecione o produto (e opcionalmente
                  o plano) e o tipo de nota. A partir dai, as notas serao emitidas automaticamente!
                </p>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className={styles.configCard}>
              <div className={styles.configNumber}>4</div>
              <div className={styles.configIcon}>
                <Icon icon="mdi:check-circle" />
              </div>
              <div className={styles.configContent}>
                <span className={styles.configTitle}>
                  Pronto!
                </span>
                <p>
                  A partir de agora, toda venda confirmada desse produto tera a nota fiscal
                  emitida automaticamente. <strong>Voce nao precisa fazer mais nada.</strong>
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </section>

      {/* Regras de Emissao */}
      <section className={styles.section}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionTitle}>Entendendo as Regras</span>
          <p className={styles.sectionSubtitle}>
            O que sao e como funcionam
          </p>
        </div>

        <Row className="g-4">
          <Col lg={6}>
            <div className={styles.participantCard}>
              <div className={`${styles.cardIcon} ${styles.iconSuccess}`}>
                <Icon icon="mdi:package-variant" />
              </div>
              <div className={styles.cardContent}>
                <div className={`${styles.cardBadge} ${styles.badgeSuccess}`}>Produto</div>
                <span className={styles.cardTitle}>Vincular Produto</span>
                <p>
                  Cada regra e vinculada a um <strong>produto</strong>. Voce pode criar uma regra
                  para todos os planos do produto ou para um <strong>plano especifico</strong>.
                </p>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className={styles.participantCard}>
              <div className={`${styles.cardIcon} ${styles.iconAffiliate}`}>
                <Icon icon="mdi:file-document" />
              </div>
              <div className={styles.cardContent}>
                <div className={`${styles.cardBadge} ${styles.badgeAffiliate}`}>Tipo de Nota</div>
                <span className={styles.cardTitle}>NF-e ou NFS-e</span>
                <p>
                  <strong>NF-e</strong> (Nota de Produto): para venda de produtos fisicos ou digitais.
                  <strong> NFS-e</strong> (Nota de Servico): para servicos, cursos e consultorias.
                  Na maioria dos casos, use <strong>NF-e</strong>.
                </p>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className={styles.participantCard}>
              <div className={`${styles.cardIcon} ${styles.iconPlatform}`}>
                <Icon icon="mdi:clock-check" />
              </div>
              <div className={styles.cardContent}>
                <div className={`${styles.cardBadge} ${styles.badgePlatform}`}>Momento</div>
                <span className={styles.cardTitle}>Pagamento Aprovado</span>
                <p>
                  A nota e emitida automaticamente quando o <strong>pagamento e confirmado</strong>.
                  Isso vale para PIX, cartao de credito e boleto.
                </p>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className={styles.participantCard}>
              <div className={`${styles.cardIcon} ${styles.iconWarning}`}>
                <Icon icon="mdi:alert-circle-outline" />
              </div>
              <div className={styles.cardContent}>
                <div className={`${styles.cardBadge} ${styles.badgeWarning}`}>Importante</div>
                <span className={styles.cardTitle}>Nao Bloqueia a Venda</span>
                <p>
                  Se por algum motivo a emissao falhar, a <strong>venda continua normalmente</strong>.
                  O erro fica registrado no historico para voce verificar depois.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </section>

      {/* Como Funciona */}
      <section className={styles.section}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionTitle}>Como Funciona o Fluxo?</span>
          <p className={styles.sectionSubtitle}>
            Da venda ate o email com o PDF
          </p>
        </div>

        <div className={styles.infoCard}>
          <Icon icon="mdi:information" className={styles.infoIcon} />
          <div>
            <p>
              Quando uma venda e confirmada:
            </p>
            <ol style={{ marginTop: '12px', marginBottom: 0, paddingLeft: '20px' }}>
              <li>O sistema <strong>detecta o pagamento confirmado</strong></li>
              <li>Verifica se existe uma <strong>regra de emissao</strong> para aquele produto</li>
              <li>Se existe, <strong>emite a nota fiscal automaticamente</strong> via Notazz</li>
              <li>O Notazz processa a nota e <strong>envia para a SEFAZ</strong></li>
              <li>Quando autorizada, o <strong>comprador recebe um email</strong> com o PDF da nota</li>
              <li>O <strong>historico</strong> e atualizado com o status da nota</li>
            </ol>
            <p style={{ marginTop: '12px', marginBottom: 0 }}>
              Todo o processo e <strong>automatico</strong> e leva apenas alguns segundos!
            </p>
          </div>
        </div>
      </section>

      {/* Historico */}
      <section className={styles.section}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionTitle}>Acompanhando as Notas</span>
          <p className={styles.sectionSubtitle}>
            Historico e estatisticas
          </p>
        </div>

        <div className={styles.infoCard}>
          <Icon icon="mdi:history" className={styles.infoIcon} />
          <div>
            <p>
              Na pagina do Notazz voce encontra:
            </p>
            <ul style={{ marginTop: '12px', marginBottom: 0, paddingLeft: '20px' }}>
              <li><strong>Cards de estatisticas:</strong> Total de notas, autorizadas, com erro e pendentes</li>
              <li><strong>Historico completo:</strong> Todas as notas emitidas com status, valor e data</li>
              <li><strong>Status em tempo real:</strong> Pendente, Processando, Autorizada ou Erro</li>
              <li><strong>Link do PDF:</strong> Quando a nota e autorizada, o link do PDF fica disponivel</li>
            </ul>
            <p style={{ marginTop: '12px', marginBottom: 0 }}>
              Use o historico para <strong>acompanhar se tudo esta funcionando</strong> e
              identificar rapidamente qualquer problema.
            </p>
          </div>
        </div>
      </section>

      {/* Perguntas Frequentes */}
      <section className={styles.section}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionTitle}>Perguntas Frequentes</span>
          <p className={styles.sectionSubtitle}>
            Duvidas comuns sobre a integracao
          </p>
        </div>

        <Row className="g-4">
          <Col lg={6}>
            <div className={styles.configCard}>
              <div className={styles.configIcon}>
                <Icon icon="mdi:help-circle" />
              </div>
              <div className={styles.configContent}>
                <span className={styles.configTitle}>
                  Preciso criar regra para cada plano?
                </span>
                <p>
                  <strong>Nao.</strong> Se voce criar uma regra sem selecionar plano (opcao
                  "Todos os planos"), ela vale para qualquer plano do produto.
                </p>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className={styles.configCard}>
              <div className={styles.configIcon}>
                <Icon icon="mdi:help-circle" />
              </div>
              <div className={styles.configContent}>
                <span className={styles.configTitle}>
                  O que acontece se a emissao falhar?
                </span>
                <p>
                  A <strong>venda continua normalmente</strong>. A emissao nunca bloqueia a venda.
                  O erro fica registrado no historico para voce verificar.
                </p>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className={styles.configCard}>
              <div className={styles.configIcon}>
                <Icon icon="mdi:help-circle" />
              </div>
              <div className={styles.configContent}>
                <span className={styles.configTitle}>
                  Posso cancelar uma nota emitida?
                </span>
                <p>
                  <strong>Sim.</strong> No historico de notas, voce pode cancelar notas que ja
                  foram emitidas diretamente pela plataforma.
                </p>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className={styles.configCard}>
              <div className={styles.configIcon}>
                <Icon icon="mdi:help-circle" />
              </div>
              <div className={styles.configContent}>
                <span className={styles.configTitle}>
                  O comprador sempre recebe email?
                </span>
                <p>
                  O email e enviado <strong>apenas quando a nota e autorizada</strong> pela SEFAZ
                  e o PDF esta disponivel.
                </p>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className={styles.configCard}>
              <div className={styles.configIcon}>
                <Icon icon="mdi:help-circle" />
              </div>
              <div className={styles.configContent}>
                <span className={styles.configTitle}>
                  NF-e ou NFS-e, qual usar?
                </span>
                <p>
                  Para <strong>produtos</strong> (fisicos ou digitais), use <strong>NF-e</strong>.
                  Para <strong>servicos</strong> (cursos, consultorias), use <strong>NFS-e</strong>.
                  Na duvida, use NF-e.
                </p>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className={styles.configCard}>
              <div className={styles.configIcon}>
                <Icon icon="mdi:help-circle" />
              </div>
              <div className={styles.configContent}>
                <span className={styles.configTitle}>
                  Preciso ter conta no Notazz?
                </span>
                <p>
                  <strong>Sim.</strong> Voce precisa de uma conta ativa no Notazz com empresa
                  configurada para emitir notas. Crie sua conta em
                  <strong> app.notazz.com</strong>.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default NotazzWiki;
